export default __webpack_public_path__ + "static/media/totalTopUp.dff86ab2.svg";